import { Navigate, Route, Routes } from "react-router-dom";
import { PageTitle } from "../../../_start/layout/core";
import { CreateFAQCategory } from "../content-management/pages/faq-category/CreateFAQCategory";
import { FAQCategoriesPage } from "../content-management/pages/faq-category/FAQCategoriesPage";
import { UpdateFAQCategory } from "../content-management/pages/faq-category/UpdateFAQCategory";
import { CreateFAQ } from "../content-management/pages/faq/CreateFAQ";
import { FAQsPage } from "../content-management/pages/faq/FAQsPage";
import { UpdateFAQ } from "../content-management/pages/faq/UpdateFAQ";
import { CreatePage } from "./pages/CreatePage";
import { PageEditContent } from "./pages/PageEditContent";
import { PagesPage } from "./pages/PagesPage";
import { UpdatePage } from "./pages/UpdatePage";

export const PageManagementPage = () => {
  return (
    <Routes>
      {/* begin::Page Routes */}
      <Route
        path="pages"
        element={
          <>
            <PageTitle>Pages</PageTitle>
            <PagesPage />
          </>
        }
      />

      <Route
        path="pages/create"
        element={
          <>
            <PageTitle>Pages</PageTitle>
            <CreatePage />
          </>
        }
      />
      <Route
        path="pages/:id/update"
        element={
          <>
            <PageTitle>Pages</PageTitle>
            <UpdatePage />
          </>
        }
      />
      <Route
        path="pages/:id/edit-content"
        element={
          <>
            <PageTitle>Pages</PageTitle>
            <PageEditContent />
          </>
        }
      />
      {/* end::Page Routes */}

      {/* FAQs */}
      <Route
        path="faqs"
        element={
          <>
            <PageTitle>FAQs</PageTitle>
            <FAQsPage />
          </>
        }
      />
      <Route
        path="faqs/create"
        element={
          <>
            <PageTitle>FAQs</PageTitle>
            <CreateFAQ cancelUrl={`/page-management/faqs`} />
          </>
        }
      />
      <Route
        path="faqs/:id/update"
        element={
          <>
            <PageTitle>FAQs</PageTitle>
            <UpdateFAQ cancelUrl={`/page-management/faqs`} />
          </>
        }
      />
      {/* FAQs */}

      {/* FAQ Categories */}
      <Route
        path="faq-categories"
        element={
          <>
            <PageTitle>FAQ Categories</PageTitle>
            <FAQCategoriesPage />
          </>
        }
      />
      <Route
        path="faq-categories/create"
        element={
          <>
            <PageTitle>FAQ Categories</PageTitle>
            <CreateFAQCategory cancelUrl="/page-management/faq-categories" />
          </>
        }
      />
      <Route
        path="faq-categories/:id/update"
        element={
          <>
            <PageTitle>FAQ Categories</PageTitle>
            <UpdateFAQCategory cancelUrl="/page-management/faq-categories" />
          </>
        }
      />
      {/* FAQ Categories */}

      <Route
        index
        element={<Navigate to="/page-management/pages" replace />}
      />
      <Route
        path="*"
        element={<Navigate to="/page-management/pages" replace />}
      />
    </Routes>
  );
};
